import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import type { DnsInventoryDto } from '@cpm/shared';
import { api } from '../api/client.js';
import { Card, CardHeader, ErrorNote, Spinner } from './ui.js';
export function DnsSummary({
  subscriptionId,
  portal = false,
}: {
  subscriptionId: string;
  portal?: boolean;
}) {
  const query = useQuery({
    queryKey: ['dns', 'summary', subscriptionId],
    queryFn: () =>
      api.get<DnsInventoryDto>(`/api/dns/domains?subscriptionId=${subscriptionId}&pageSize=100`),
  });
  if (query.isPending) return <Spinner />;
  if (query.error) return <ErrorNote error={query.error} />;
  return (
    <Card>
      <CardHeader
        title="DNS"
        description={`${query.data.total} assigned domains · ${query.data.items.filter((row) => row.zoneId).length} zones${query.data.total > query.data.items.length ? ' shown (partial list)' : ''}`}
        actions={
          <Link
            className="text-sm text-blue-600 underline"
            to={`${portal ? '/portal/dns' : '/dns'}?subscriptionId=${subscriptionId}`}
          >
            Manage DNS
          </Link>
        }
      />
      <div className="px-5 pb-4 text-sm text-slate-500">
        {query.data.items.length
          ? query.data.items
              .slice(0, 3)
              .map((row) => row.name)
              .join(', ')
          : 'No assigned domains yet.'}
      </div>
    </Card>
  );
}
